/**
 * Directive: datePicker
 */
angular.module('acme.common.directive.datePicker', [
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences'
])
.directive('datePicker', ['$filter', '$timeout', 'HelpersService', 'CalendarService', 'UserPreferencesService', function($filter, $timeout, HelpersService, CalendarService, UserPreferencesService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/datePicker/datePicker.tpl.html',
      scope: {
        model: '=',
        format: '@',
        required: '@',
        typeLabel: '@typelabel',
        appendToBody: '@',
        showButton: '@',
        isDisabled: '=disabled',
        datePickerIndex: '@datepickerindex',
        datePickerMode: '@',
        startingDay: '=',
        ariaLabel: '@',
        minDate: '@',
        maxDate: '@',
        placeholder: '@'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs

        $scope.datePickerIndex = $scope.datePickerIndex || 0;

        $scope.datePicker.focusElement = function() {
          if ($scope.datePicker.focusTimeout) {
            $timeout.cancel($scope.datePicker.focusTimeout);
          }
          // next tick
          $scope.datePicker.focusTimeout = $timeout(function() {
            if ($element.find('#date-picker-' + $scope.datePickerIndex + '-shown').length) {
              $element.find('#date-picker-' + $scope.datePickerIndex + '-shown').get(0).focus();
            }
          });
        };
      },

      controller: ['$scope',  function($scope) {

        $scope.datePicker = {

          dateFormat: 'M!/d!/yyyy',
          isPreferenceLoaded: false,
          isOpen: false,
          isGroupOpen: false,
          minDate: new Date(1900, 0, 1, 0, 0, 0, 0),
          maxDate: new Date(2032, 12, 31, 23, 59, 59, 999),
          invalidDate: 'Invalid date format',
          placeholder: 'Enter date',
          focusTimeout: false,

          dateOptions: {
            formatYear: 'yy',
            startingDay: UserPreferencesService.getStartDayOfWeek(),
            formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
            showWeeks: false
          },

          init: function() {
            $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
            $scope.$watch('datePicker.isOpen', this.onIsOpenUpdate);
            $scope.$on('$destroy', this.onDestroy);
            $timeout(function () {
              $scope.datePicker.isPreferenceLoaded = true;
            },100);
            if ($scope.minDate) {
              this.minDate = $scope.minDate;
            }
            if ($scope.maxDate) {
              this.maxDate = $scope.maxDate;
            }
            if ($scope.placeholder) {
              this.placeholder = $scope.placeholder;
            }
          },

          toggleOpen: function() {
            return (this.isOpen = !this.isOpen);
          },

          toggleGroupOpen: function() {
            return (this.isGroupOpen = !this.isGroupOpen);
          },

          getDateFormat: function() {
            return this.dateFormat;
          },

          open: function($event) {
            $event.preventDefault();
            $event.stopPropagation();

            if ($scope.showButton) {
              this.isGroupOpen = this.toggleGroupOpen();
            }else {
              this.isOpen = this.toggleOpen();
            }
          },

          clearDate: function() {
            $scope.model = null;
            if (typeof(this.focusElement) === 'function') {
              this.focusElement();
            }
          },
          
          onDateFormatLoad: function (e, data) {
            var self = $scope.datePicker;
            self.dateFormat = 'M!/d!/yyyy';
            self.dateOptions.showWeeks = false;
            self.dateOptions.startingDay = UserPreferencesService.getStartDayOfWeek();
            self.dateOptions.formatDayTitle = UserPreferencesService.getDateFormat('month', 'dateFormat');
          },

          onIsOpenUpdate: function(n, o) {
            if (n !== o && n === false) {
              $scope.datePicker.focusElement();
            }
          },

          onDestroy: function(e) {
            if ($scope.datePicker.focusTimeout) {
              $timeout.cancel($scope.datePicker.focusTimeout);
            }
          }

        };
        
        $scope.datePicker.init();

      }]

    };

}]);